{
  "chat": {
    "title": "DreamBot",
    "subtitle": "AI Sleep Concierge",
    "placeholder": "Ask about sleep, pain, or products...",
    "send": "Send message",
    "restart": "Restart Chat",
    "close": "Close chat",
    "toggleTheme": "Toggle theme",
    "typing": "DreamBot is typing...",
    "error": {
      "generic": "Something went wrong. Please try again.",
      "network": "Network error. Check your connection.",
      "timeout": "Request timed out. Please try again.",
      "retry": "Try Again"
    }
  },
  "greeting": {
    "welcome": "Welcome to Mattress Unboxed! I'm DreamBot. To find your perfect sleep setup, tell me: how do you usually sleep?",
    "continueConversation": "Welcome back!",
    "continueDescription": "Would you like to continue where you left off, or start a fresh conversation?",
    "continueButton": "Continue conversation",
    "startNewButton": "Start fresh"
  },
  "quiz": {
    "sleepPosition": {
      "question": "How do you usually sleep?",
      "side": "Side Sleeper",
      "back": "Back Sleeper",
      "stomach": "Stomach Sleeper",
      "combination": "Combination"
    },
    "painPoints": {
      "question": "Do you experience any specific discomfort when waking up?",
      "lowerBack": "Lower Back Pain",
      "shoulder": "Shoulder Pain",
      "hot": "Runs Hot",
      "none": "No Pain"
    },
    "firmness": {
      "question": "When it comes to feel, what do you usually prefer?",
      "soft": "Cloud-like Soft",
      "medium": "Perfect Medium",
      "firm": "Supportive Firm"
    },
    "budget": {
      "question": "What is your approximate budget?",
      "under1000": "Under $1000",
      "standard": "$1000 - $1600",
      "luxury": "Price is no object"
    },
    "bedSize": {
      "question": "What bed size are you shopping for?",
      "twin": "Twin",
      "twinXL": "Twin XL",
      "full": "Full",
      "queen": "Queen",
      "king": "King",
      "calKing": "Cal King"
    }
  },
  "recommendations": {
    "analyzing": "Analyzing your sleep profile...",
    "bestMatch": "Best overall match:",
    "alternative": "Strong alternative:",
    "anotherOption": "Another great option:",
    "viewDetails": "View details",
    "warranty": "Ask about Warranty",
    "shipping": "Shipping Info",
    "startOver": "Start Over"
  },
  "suggestions": {
    "quickStarts": "Quick starts",
    "findPerfect": "Help me find the perfect mattress",
    "whatSpecial": "What makes your mattresses special?",
    "bestSellers": "Tell me about your best sellers",
    "backPain": "I need help with back pain"
  },
  "accessibility": {
    "inputDescription": "Type your message and press Enter to send",
    "liveRegion": "DreamBot says: {{message}}",
    "quickReplyGroup": "Quick reply options",
    "quickReply": "Quick reply: {{label}}",
    "closeInstruction": "Close chat (Ctrl+K or swipe down)",
    "zoomInstruction": "Scroll to zoom • Click and drag to pan"
  }
}
